/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable no-unused-expressions */
import React from 'react';

const InputTextBox = props => {
  const {
    id,
    name,
    type,
    value = '',
    text,
    err,
    readOnly,
    change,
    cbk,
    autoFocus,
    mandatory = false,
    placeHolder,
    focusCbk,
  } = props;

  const changeValue = async event => {
    change && change(id, event.currentTarget.value);
  };

  return (
    <div className={`inputWrapper ${id}`}>
      <div className={`inputCont ${readOnly && 'readOnlyInput'}`}>
        <input
          id={id}
          placeholder={placeHolder}
          autoFocus={autoFocus}
          autoComplete="off"
          name={name}
          className="inputBox"
          type={type}
          onChange={e => changeValue(e)}
          value={value}
          readOnly={readOnly}
          onKeyUp={e => cbk && cbk(e)}
          required
          onFocus={e => focusCbk && focusCbk(e)}
        />
        {!readOnly && <span className="focusBorder" />}
        <label htmlFor={id} className="inputLabel">
          {text}
          {mandatory && <span className="required">*</span>}
        </label>
      </div>
      <span
        className="errMsgText"
        dangerouslySetInnerHTML={{
          __html: err || '',
        }}
      />
    </div>
  );
};

export default InputTextBox;
